import AccountProfileController from "./controller";
import UpdateUserProfileForm from "./components/form-update-user-profile";

const modul = angular
    .module("AccountProfileModule", [])
    .directive("updateUserProfileForm", UpdateUserProfileForm)
    .controller("AccountProfileController", AccountProfileController);

export default modul.name;
